import { forwardRef } from 'react'

import { SystemIconTemplate } from '../../template/system-icon-template'
import { IconProps } from '../../types/types'

export const ArrowRightSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	return (
		<SystemIconTemplate ref={ref} {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.21413 18.7796C9.47158 19.0646 9.91906 19.0643 10.176 18.7789L15.6775 12.6691C16.02 12.2888 16.02 11.7112 15.6775 11.3309L10.233 5.28436C9.94553 4.96515 9.44505 4.96475 9.15711 5.2835C8.90798 5.55929 8.90798 5.97887 9.15711 6.25466L14.0444 11.6648C14.2163 11.8552 14.2163 12.1448 14.0444 12.3352L9.21413 17.6822C8.93261 17.9939 8.93261 18.468 9.21413 18.7796Z"
				fill="currentColor"
			/>
		</SystemIconTemplate>
	)
})
